import React from 'react';

export interface PlanUpgradeListItem {
  id: string;
  name: string;
  seatPriceCents: number;
}

export interface PlanUpgradeListProps {
  plans: PlanUpgradeListItem[];
}

/**
 * Sprint 17, story-082, State 2 of the shared Add Seats surface: the org's current plan has no
 * linked add-ons, so this read-only list shows other plans that do, plus their prices. No plan
 * row is clickable — this is informational plus a "Contact us to switch plans" hand-off, not a
 * self-serve plan change (see AddAddonModal for the Contact Us action itself).
 */
export const PlanUpgradeList: React.FC<PlanUpgradeListProps> = ({ plans }) => {
  if (plans.length === 0) {
    return (
      <div className="text-center py-6 text-gray-500 dark:text-gray-400 border border-dashed border-gray-300 dark:border-gray-600 rounded-lg">
        <p>No seat packages are configured yet. Contact us to add seats.</p>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {plans.map((plan) => (
        <div
          key={plan.id}
          className="flex items-center justify-between p-4 border border-gray-300 dark:border-gray-600 rounded-lg"
        >
          <span className="font-semibold text-gray-900 dark:text-white uppercase">{plan.name}</span>
          <span className="text-sm text-gray-700 dark:text-gray-300">
            Additional seat ${(plan.seatPriceCents / 100).toFixed(2)}/mo
          </span>
        </div>
      ))}
    </div>
  );
};

export default PlanUpgradeList;
